<template>
  <v-container class="mt-4 ml-2" fluid>

    <!-- Nueva Tabla: Documentos de Procesos (Jefes de Depto) -->
    <v-row class="mt-6" v-if="puestos.includes(getdatosUsuarioERPERP.idpuesto)">
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title class="pb-0">
            <span class="text-subtitle-1">Documentos de Procesos (Jefes de Depto.)</span>
            <v-spacer></v-spacer>

            <v-btn color="primary" dark class="text-capitalize mr-2" @click="crearDocumento()" small tile>
              <v-icon left small>mdi-plus</v-icon>
              Subir Documento
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-data-table :headers="headersDocumentos" :items="documentosFiltrados" :search="search"
              class="elevation-0" :mobile-breakpoint="100" dense>
              
              <template v-slot:item.archivo_nombre="{ item }">
                <v-btn v-if="item.archivo_nombre" icon small color="primary" @click="descargarDocumento(item)">
                  <v-icon>mdi-file-download</v-icon>
                </v-btn>
              </template>

              <template v-slot:item.validacion_dc="{ item }">
                <v-chip small :color="item.validacion_dc ? 'green' : 'amber'" dark>
                  {{ item.validacion_dc ? 'Validado' : 'Pendiente' }}
                </v-chip>
              </template>

              <template v-slot:item.acciones="{ item }">
                <v-row>
                  <v-btn small icon @click="abrirDialogDocumento(item)" v-if="canEdit">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn v-if="tieneAccesoDoc(item)" small color="red" dark icon @click="eliminarDocumento(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-row>
              </template>

            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>

      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title class="pb-0">
            <span class="text-subtitle-1">Validación de Procesos Estandarizados</span>
            <v-spacer></v-spacer>

            <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar proceso..." single-line hide-details
              dense class="mr-4" style="max-width: 300px;"></v-text-field>

            <v-btn color="primary" dark class="text-capitalize mr-2" @click="crearProceso()" small tile>
              <v-icon left small>mdi-plus</v-icon>
              Nuevo Proceso
            </v-btn>

            <v-btn color="primary" dark class="text-capitalize" @click="initialize()" small tile>
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <!-- Barra de avance y tarjetas -->
            <v-row class="mt-4">
              <v-col cols="12" md="3">
                <v-card outlined class="text-center pa-4" color="grey lighten-4">
                  <v-icon color="primary" size="32" class="mb-2">mdi-chart-donut</v-icon>
                  <div class="text-h4 font-weight-bold primary--text">{{ avancePorcentaje }}%</div>
                  <div class="text-caption">Avance Total</div>
                </v-card>
              </v-col>

              <v-col cols="6" md="3">
                <v-card outlined class="text-center pa-4" color="green lighten-4">
                  <v-icon color="green" size="32" class="mb-2">mdi-check-circle</v-icon>
                  <div class="text-h4 font-weight-bold green--text">{{ getCompleted.length }}</div>
                  <div class="text-caption">Procesos Completados</div>
                </v-card>
              </v-col>

              <v-col cols="6" md="3">
                <v-card outlined class="text-center pa-4" color="amber lighten-4">
                  <v-icon color="amber darken-2" size="32" class="mb-2">mdi-clock-alert</v-icon>
                  <div class="text-h4 font-weight-bold amber--text">{{ getReview.length }}</div>
                  <div class="text-caption">Procesos Pendientes</div>
                </v-card>
              </v-col>

              <v-col cols="6" md="3">
                <v-card outlined class="text-center pa-4" color="red lighten-4">
                  <v-icon color="red" size="32" class="mb-2">mdi-close-circle</v-icon>
                  <div class="text-h4 font-weight-bold red--text">{{ getReject.length }}</div>
                  <div class="text-caption">Procesos Rechazados</div>
                </v-card>
              </v-col>
            </v-row>

            <!-- Filtro por departamento -->
            <v-row justify="end" class="mt-4">
              <v-col cols="12" md="4" lg="3">
                <v-select label="Filtrar por departamento" filled dense hide-details :items="departamentos"
                  item-text="departamento" item-value="id" v-model="departamentoFiltro" clearable></v-select>
              </v-col>
            </v-row>

            <!-- Tabla de validación -->
            <v-row class="mt-4">
              <v-col cols="12">
                <v-data-table :headers="headersValidacion" :items="procesosFiltrados" :search="search"
                  class="elevation-0" :mobile-breakpoint="100" dense>
                  <template v-slot:item.index="{ index }">{{ index + 1 }}</template>

                  <template v-slot:item.escuela="{ item }">
                    <v-chip small color="colorinbi" dark v-if="item.escuela == 1">INBI</v-chip>
                    <v-chip small color="colorfast" dark v-else-if="item.escuela == 2">FAST</v-chip>
                    <v-chip small color="grey" dark v-else>—</v-chip>
                  </template>

                  <template v-slot:item.documentosProceso="{ item }">
                    <div class="d-flex align-center flex-wrap">
                      <v-btn v-if="item.audio_name" icon small :color="item.isPlaying ? 'error' : 'success'"
                        @click="reproducirAudio(item)" class="ml-1" :title="item.isPlaying ? 'Pausar audio' : 'Reproducir audio'">
                        <v-icon>{{ item.isPlaying ? 'mdi-pause' : 'mdi-play' }}</v-icon>
                      </v-btn>
                      <v-btn v-if="item.audio_name" icon small color="primary" @click="descargarAudio(item)" class="ml-1"
                        title="Descargar audio">
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                      <v-chip v-if="item.transcription" x-small class="ml-1" color="green lighten-4" text-color="green darken-3">
                        Transcrito
                      </v-chip>
                      <v-btn v-if="item.transcription" icon small color="indigo" class="ml-1"
                        @click="descargarWordProceso(item)" title="Descargar Word de la transcripción">
                        <v-icon>mdi-file-word</v-icon>
                      </v-btn>
                      <v-btn v-if="getPdfNombre(item, 'archivo')" icon small color="primary" class="ml-1"
                        @click="verPdf(item, 'archivo')" title="Ver PDF del proceso">
                        <v-icon>mdi-file-pdf-box</v-icon>
                      </v-btn>
                      <v-btn v-if="getPdfNombre(item, 'diagrama')" icon small color="secondary" class="ml-1"
                        @click="verPdf(item, 'diagrama')" title="Ver diagrama">
                        <v-icon>mdi-file-tree</v-icon>
                      </v-btn>
                    </div>
                  </template>

                  <template v-slot:item.validacionDueno="{ item }">
                    <v-chip
                      small
                      label
                      :color="item.validacion_dueno ? 'success' : (canValidarDueno(item) ? 'amber lighten-3' : 'grey lighten-2')"
                      :text-color="item.validacion_dueno ? 'white' : 'grey darken-2'"
                      @click="updateTareaCheck(item, 'dueno')"
                    >
                      <v-icon left x-small>{{ item.validacion_dueno ? 'mdi-check' : 'mdi-close' }}</v-icon>
                      {{ item.validacion_dueno ? 'Valido' : 'Invalido' }}
                    </v-chip>
                  </template>

                  <template v-slot:item.validacionLider="{ item }">
                    <v-chip
                      small
                      label
                      :color="item.validacion_lider ? 'success' : (canValidarDirector(item) ? 'amber lighten-3' : 'grey lighten-2')"
                      :text-color="item.validacion_lider ? 'white' : 'grey darken-2'"
                      @click="updateTareaCheck(item, 'lider')"
                    >
                      <v-icon left x-small>{{ item.validacion_lider ? 'mdi-check' : 'mdi-close' }}</v-icon>
                      {{ item.validacion_lider ? 'Valido' : 'Invalido' }}
                    </v-chip>
                  </template>

                  <template v-slot:item.validacionSocio="{ item }">
                    <v-chip
                      small
                      label
                      :color="item.validacion_socio ? 'success' : (canValidarControlInterno(item) ? 'amber lighten-3' : 'grey lighten-2')"
                      :text-color="item.validacion_socio ? 'white' : 'grey darken-2'"
                      @click="updateTareaCheck(item, 'socio')"
                    >
                      <v-icon left x-small>{{ item.validacion_socio ? 'mdi-check' : 'mdi-close' }}</v-icon>
                      {{ item.validacion_socio ? 'Valido' : 'Invalido' }}
                    </v-chip>
                  </template>

                  <template v-slot:item.estatus="{ item }">
                    <!-- No deshabilitar si está aprobado: en Vuetify el disabled pinta todo gris. -->
                    <v-btn rounded
                      :disabled="item.estatusKey === 'approved' ? false : !item.validacion_socio"
                      :color="getColorEstatus(item.estatus, item.estatusKey)"
                      dark
                      x-small depressed @click.prevent>
                      {{ item.estatus }}
                    </v-btn>
                    <!-- <v-chip small :color="getColorEstatus(item.estatus)">
                      {{ item.estatus }}
                    </v-chip> -->
                  </template>

                  <template v-slot:item.acciones="{ item }">
                    <v-btn small icon @click="abrirDialog(item, true)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn v-if="tieneAccesoAlProceso(item)" small color="red" dark icon @click="eliminar(item)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>


    <!-- Dialog para ver/editar proceso (mantenido del original) -->
    <v-dialog v-model="dialog" max-width="750px" persistent>
      <v-card class="shadowCard">

        <!-- Header -->
        <v-card-title primary-title>
          <span class="text-subtitle-1">Procesos</span>
        </v-card-title>

        <!-- Contenido -->
        <v-card-text>

          <!-- Título del proceso -->
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="form.titulo" label="Título del proceso" :disabled="!modoEdicion" filled
                dense></v-text-field>
            </v-col>
          </v-row>

          <!-- Escuela (INBI / FAST) -->
          <v-row class="mt-2">
            <v-col cols="12">
              <div class="text-caption mb-1">Escuela</div>
              <v-radio-group v-model="form.escuela" :disabled="!modoEdicion" hide-details class="mt-0">
                <v-radio label="INBI" :value="1" color="primary"></v-radio>
                <v-radio label="FAST" :value="2" color="primary"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <!-- Departamento / responsables (mantener igual) -->
          <v-row class="mt-2">
            <!-- JEFE DE DEPARTAMENTO -->
            <v-col cols="6">
              <v-autocomplete v-model="form.id_jefe_departamento" :items="filterJefes" item-text="nombre_completo"
                item-value="id" label="Seleccionar jefe de departamento" filled dense :disabled="!modoEdicion"
                clearable></v-autocomplete>
            </v-col>

            <!-- RESPONSABLE -->
            <v-col cols="6">
              <v-autocomplete v-model="form.id_responsable" :items="filterResponsables" item-text="nombre_completo"
                item-value="id" label="Seleccionar responsable" filled dense :disabled="!modoEdicion"
                clearable></v-autocomplete>
            </v-col>

          </v-row>
          <v-row>
            <v-col cols="6">
              <v-autocomplete v-model="form.id_departamento" :items="departamentos" item-text="departamento"
                item-value="id" label="Seleccionar departamento" filled dense :disabled="!modoEdicion"
                clearable></v-autocomplete>
            </v-col>
          </v-row>

          <!-- === Sección de Audio (grabar / subir → transcripción → PDF) === -->
          <v-row class="mt-6">
            <v-col cols="12">
              <v-row v-if="showRecording()" align="center" class="mb-1">
                <div class="text-subtitle-2">
                  Grabación del proceso (audio)
                  <v-btn icon color="pink" x-small @click="mostrarGuia = true">
                    <v-icon small>mdi-microphone-question</v-icon>
                  </v-btn>
                </div>
              </v-row>
              <v-card outlined class="pa-4">
                <v-row align="center" justify="center">
                  <v-col cols="auto" v-if="showRecording() && modoEdicion">
                    <v-btn v-if="!isRecording" text large color="primary" @click="startRecording">
                      <v-icon left large>mdi-microphone</v-icon>
                      Iniciar Grabación
                    </v-btn>
                    <v-btn v-else text large color="error" @click="stopRecording">
                      <v-icon left large>mdi-stop</v-icon>
                      Detener Grabación
                    </v-btn>
                  </v-col>

                  <v-col cols="12" md="8" v-if="modoEdicion && showRecording()">
                    <v-file-input
                      v-model="archivoAudio"
                      accept="audio/*,.mp3,.wav,.webm,.ogg,.m4a"
                      filled
                      dense
                      clearable
                      prepend-icon="mdi-file-music"
                      label="O subir archivo de audio"
                      @change="onAudioFileChange"
                    />
                    <div class="text-caption grey--text text--darken-1 mt-1">
                      Un audio de una hora supera el límite de Whisper (25 MB). Al guardar se parte en bloques de 10 minutos, se transcribe cada uno y el texto se junta en un Word.
                    </div>
                  </v-col>

                  <v-col cols="12" class="text-center mt-2" v-if="audioUrl || form.audioBase64 || form.audio_name">
                    <audio
                      controls
                      :src="audioUrl || getAudioSrc(form.audioBase64) || (form.audio_name ? (URL_AUDIO + form.audio_name) : '')"
                      class="mt-2"
                      style="width: 100%; max-width: 500px;"
                    ></audio>
                  </v-col>

                  <v-col cols="12" class="text-center mt-2 grey--text text--darken-1"
                    v-if="!audioUrl && !form.audioBase64 && !form.audio_name && !isRecording && !archivoAudio">
                    <span v-if="showRecording()">
                      No hay grabación. Graba o sube un audio; al guardar se transcribe y genera el PDF.
                    </span>
                    <span v-else>
                      Solo el documentador (responsable) puede grabar o subir audio.
                    </span>
                  </v-col>

                  <v-skeleton-loader
                    v-if="showSkeleton"
                    v-bind="attrs"
                    style="width: 50vw"
                    type="list-item-two-line"
                    class="shadow-0"
                  ></v-skeleton-loader>
                </v-row>

                <v-row class="mt-3" justify="center" v-if="modoEdicion && (audioUrl || form.audioBase64 || archivoAudio)">
                  <v-btn text color="error" small @click="clearAudio">
                    <v-icon left small>mdi-delete</v-icon>
                    Eliminar audio actual
                  </v-btn>
                </v-row>

                <v-row class="mt-3" justify="center" v-if="transcripcion">
                  <v-col cols="12" class="text-justify grey--text text--darken-1"
                    style="max-height: 120px; overflow-y: auto;">
                    <div class="text-caption font-weight-medium mb-1">Transcripción</div>
                    {{ transcripcion }}
                  </v-col>
                  <v-col cols="12" class="text-center">
                    <v-btn small color="indigo" dark @click="descargarWord">
                      <v-icon left small>mdi-file-word</v-icon>
                      Descargar Word
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>

              <v-card outlined class="pa-4 mt-3" v-if="blueprint || pdfURL || pdfBase64">
                <v-row align="center" justify="center">
                  <v-col cols="12" class="text-center grey--text text--darken-1">
                    Se generó el PDF del proceso a partir del audio. Puedes verlo o descargarlo.
                  </v-col>
                  <v-col cols="12" class="text-center">
                    <v-btn small color="primary" text @click="definePdfDwnl">
                      Descargar PDF generado
                    </v-btn>
                    <v-btn small color="primary" text v-if="blueprint" @click="markdownDialog = true">
                      Ver contenido
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <!-- === Sección de documentos PDF del proceso === -->
          <v-row class="mt-6">
            <v-col cols="12">
              <div class="text-subtitle-2 mb-3">Documentos del proceso (PDF)</div>
              <v-card outlined class="pa-4">
                <v-row>
                  <v-col cols="12" md="6">
                    <div class="text-caption mb-2">1. Archivo del Proceso</div>
                    <v-file-input
                      v-model="archivoProcesoPdf"
                      :disabled="!modoEdicion"
                      accept="application/pdf"
                      filled
                      dense
                      clearable
                      prepend-icon="mdi-file-pdf-box"
                      label="Subir Archivo del Proceso (PDF)"
                      @change="onPdfChange($event, 'archivo')"
                    />
                    <div class="d-flex align-center mt-2" v-if="getPdfNombre(form, 'archivo') || archivoProcesoPdf">
                      <v-btn small class="mr-2" color="primary" @click="verPdf(form, 'archivo')">
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn small class="mr-2" color="primary" @click="descargarPdfProceso(form, 'archivo')">
                        <v-icon small>mdi-download</v-icon>
                      </v-btn>
                      <v-btn v-if="modoEdicion" small class="mr-2" color="error" @click="eliminarPdfProceso('archivo')">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="getPdfNombre(form, 'archivo')" class="text-caption mt-2 blue--text text--darken-2">
                      Archivo actual: {{ getPdfNombre(form, 'archivo') }}
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="text-caption mb-2">2. Diagrama del proceso</div>
                    <v-file-input
                      v-model="diagramaProcesoPdf"
                      :disabled="!modoEdicion"
                      accept="application/pdf"
                      filled
                      dense
                      clearable
                      prepend-icon="mdi-file-pdf-box"
                      label="Subir Diagrama del Proceso (PDF)"
                      @change="onPdfChange($event, 'diagrama')"
                    />
                    <div class="d-flex align-center mt-2" v-if="getPdfNombre(form, 'diagrama') || diagramaProcesoPdf">
                      <v-btn small class="mr-2" color="secondary" @click="verPdf(form, 'diagrama')">
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn small class="mr-2" color="secondary" @click="descargarPdfProceso(form, 'diagrama')">
                        <v-icon small>mdi-download</v-icon>
                      </v-btn>
                      <v-btn v-if="modoEdicion" small class="mr-2" color="error" @click="eliminarPdfProceso('diagrama')">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="getPdfNombre(form, 'diagrama')" class="text-caption mt-2 red--text text--darken-2">
                      Archivo actual: {{ getPdfNombre(form, 'diagrama') }}
                    </div>
                  </v-col>
                  <v-col cols="12" class="text-center mt-3 grey--text text--darken-1"
                    v-if="!getPdfNombre(form, 'archivo') && !archivoProcesoPdf && !getPdfNombre(form, 'diagrama') && !diagramaProcesoPdf">
                    No hay PDFs cargados para este proceso.
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <!-- Observaciones (mantener) -->
          <v-row class="mt-6">
            <v-col cols="12">
              <v-textarea v-model="form.observacion" label="Observaciones" :disabled="!modoEdicion" filled dense
                auto-grow rows="3"></v-textarea>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-row justify="end">
            <v-col cols="12" md="3">
              <v-btn color="red" dark tile block small @click="dialog = false" text>
                Cerrar
              </v-btn>
            </v-col>
            <v-col cols="12" md="3" v-if="puedeEditar">
              <v-btn color="primary" dark tile block small @click="editarProceso()" text>
                <v-icon left small>mdi-pencil</v-icon>
                Editar
              </v-btn>
            </v-col>
            <v-col v-if="modoEdicion" cols="12" md="3">
              <v-btn color="green" dark tile block small @click="guardar" text>
                <v-icon left small>mdi-content-save</v-icon>
                Guardar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmDialog v-model="confirm" :titulo="confirmTitulo" :mensaje="confirmMensaje" @emitConfirm="requestUpdateValidacion" />
    <MarkdownViewer v-model="markdownDialog" :markdown="renderedMarkdown" />
    <guia-grabacion-audio v-model="mostrarGuia" @empezar-grabacion="iniciarGrabacionDesdeGuia" />
    <v-dialog v-model="pdfPreviewDialog" max-width="1100px">
      <v-card>
        <v-card-title class="text-subtitle-1">{{ pdfPreviewTitle }}</v-card-title>
        <v-card-text style="height: 75vh;">
          <iframe v-if="pdfPreviewUrl" :src="pdfPreviewUrl" width="100%" height="100%" style="border: none;"></iframe>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" :disabled="!pdfPreviewTipo" @click="descargarPdfPreview">
            <v-icon left small>mdi-download</v-icon>
            Descargar PDF
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="cerrarPreviewPdf">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />

    <!-- Dialog para Documentos (DOC/PDF) -->
    <v-dialog v-model="dialogDocumento" max-width="600px" persistent>
      <v-card class="shadowCard">
        <v-card-title primary-title>
          <span class="text-subtitle-1">{{ formDoc.id ? 'Editar' : 'Nuevo' }} Documento de Proceso</span>
        </v-card-title>
        <v-card-text>
          <v-alert type="info" text border="left" class="mb-4" dense outlined>
            <div class="text-caption">
              <b>Importante:</b> Una vez que el documento sea subido al servidor,
              los datos base (Folio, Nombre, Depto) y el archivo <b>no podrán ser editados</b>. 
              Solo se permitirá la actualización de estatus y comentarios.
            </div>
          </v-alert>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="formDoc.folio" label="Folio de documento" filled dense disabled></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="formDoc.nombre_documento" label="Nombre del documento" filled dense :disabled="!canEdit"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-autocomplete v-model="formDoc.id_departamento" :items="departamentos" item-text="departamento"
                item-value="id" label="Seleccionar departamento" filled dense clearable :disabled="!canEdit"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-file-input v-model="archivoDoc" label="Subir archivo (PDF, DOC, DOCX)" accept=".pdf,.doc,.docx" filled
                dense prepend-icon="mdi-file-document" :disabled="!!formDoc.id"></v-file-input>
              <div v-if="formDoc.archivo_nombre" class="text-caption blue--text">
                Archivo actual: {{ formDoc.archivo_nombre }}
              </div>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="formDoc.comentarios" label="Comentarios" filled dense rows="3" auto-grow></v-textarea>
            </v-col>
            <v-col cols="12" md="6">
              <v-select v-model="formDoc.estatus" :items="['Pendiente', 'Aprobado', 'Rechazado']" label="Estatus" filled
                dense></v-select>
            </v-col>
            <v-col cols="12" md="6" v-if="[1, 2574].includes(this.getdatosUsuarioERPERP.iderp)">
              <v-checkbox v-model="formDoc.validacion_dc" label="Validación Dirección y Calidad" color="success" dense></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialogDocumento = false" small tile>Cancelar</v-btn>
          <v-btn color="green" dark @click="guardarDocumento" small tile>Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
// Componentes
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue';
import ConfirmDialog from '@/components/procesos/ConfirmDialog.vue'
import GuiaGrabacionAudio from '@/components/procesos/GuiaAudioDialog.vue'
import MarkdownViewer from '@/components/procesos/MarkdownDialog.vue'
import validarErrores from '@/mixins//validarErrores'
import funcionesExcel from '@/mixins/funcionesExcel'
import MarkdownIt from 'markdown-it'

const md = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: true,
})

export default {
  mixins: [validarErrores, funcionesExcel],

  components: {
    Alerta,
    carga,
    ConfirmDialog,
    GuiaGrabacionAudio,
    MarkdownViewer,
  },

  data: () => ({
    attrs: {
      class: 'mb-6',
      boilerplate: true,
      elevation: 2,
    },
    parametros: {
      dialogError: false,
      mensaje: '',
      color: ''
    },
    mostrarGuia: false,
    showSkeleton: false,
    respuestaAlerta: false,
    loader: true,
    cargar: false,
    search: '',
    departamentoFiltro: '',
    avanceTotal: 75,
    procesosCompletados: 4,
    procesosPendientes: 3,
    procesosRechazados: 3,
    procesos: [],
    departamentos: [],
    personal: [],
    headersValidacion: [
      { text: '#', value: 'index' },
      { text: 'Procesos', value: 'titulo' },
      { text: 'Escuela', value: 'escuela' },
      { text: 'Departamento', value: 'departamento' },
      { text: 'Dueño de proceso', value: 'jefe_depto' },
      { text: 'Documentador', value: 'responsable' },
      { text: 'Documentos del proceso', value: 'documentosProceso', sortable: false },
      { text: 'Validación por Dueño', value: 'validacionDueno', sortable: false },
      { text: 'Validación por Director', value: 'validacionLider', sortable: false },
      { text: 'Validación por Jefe de Control Interno', value: 'validacionSocio', sortable: false },
      { text: 'Estatus', value: 'estatus' },
      { text: '', value: 'acciones', sortable: false },
    ],
    modoEdicion: false,
    puedeEditar: false,
    dialog: false,
    form: {
      id: null,
      id_departamento: '',
      id_usuario: '',
      nombre_completo: '',
      titulo: '',
      proceso: '',
      observacion: '',
      id_jefe_departamento: 0,
      id_responsable: 0,
      escuela: 1,
    },
    archivoProcesoPdf: null,
    diagramaProcesoPdf: null,
    archivoProcesoExistente: '',
    diagramaProcesoExistente: '',
    eliminarArchivoProcesoPdf: false,
    eliminarDiagramaProcesoPdf: false,
    pdfPreviewDialog: false,
    pdfPreviewUrl: '',
    pdfPreviewTitle: '',
    pdfPreviewTipo: '',
    pdfPreviewItem: null,
    // Audio / transcripción
    audioUrl: null,
    audioBlob: null,
    audioStream: null,
    mediaRecorder: null,
    audioChunks: [],
    archivoAudio: null,
    isRecording: false,
    hasRecordedAudio: false,
    transcripcion: '',
    docxBase64: '',
    blueprint: '',
    pdfBase64: '',
    pdfURL: '',
    markdownDialog: false,
    pdfName: 'procesos.pdf',
    audioName: '',
    URL_AUDIO: 'https://escuelakpi.club/audios/',
    confirm: false,
    confirmMensaje: "",
    confirmTitulo: "",
    validacionDueno: false,
    validacionLider: false,
    validacionSocio: false,
    fromValidation: "",
    // Data para nueva tabla de documentos
    dialogDocumento: false,
    archivoDoc: null,
    documentosProcesos: [],
    formDoc: {
      id: null,
      folio: '',
      nombre_documento: '',
      archivo_nombre: '',
      estatus: 'Pendiente',
      validacion_dc: 0,
      comentarios: '',
      id_departamento: ''
    },
    headersDocumentos: [
      { text: 'Folio', value: 'folio' },
      { text: 'Nombre Documento', value: 'nombre_documento' },
      { text: 'Departamento', value: 'departamento' },
      { text: 'Documento', value: 'archivo_nombre', sortable: false },
      { text: 'Estatus', value: 'estatus' },
      { text: 'Validación D.C.', value: 'validacion_dc', sortable: false },
      { text: 'Comentarios', value: 'comentarios' },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
    puestos:[11, 12, 40, 54, 56, 68, 107],

    accesosProcesos: [1, 718, 334, 568, 1312, 2720],
    // Data para nueva tabla de documentos
    dialogDocumento: false,
    archivoDoc: null,
    documentosProcesos: [],
    formDoc: {
      id: null,
      folio: '',
      nombre_documento: '',
      archivo_nombre: '',
      estatus: 'Pendiente',
      validacion_dc: 0,
      comentarios: '',
      id_departamento: ''
    },
    headersDocumentos: [
      { text: 'Folio', value: 'folio' },
      { text: 'Nombre Documento', value: 'nombre_documento' },
      { text: 'Departamento', value: 'departamento' },
      { text: 'Documento', value: 'archivo_nombre', sortable: false },
      { text: 'Estatus', value: 'estatus' },
      { text: 'Validación D.C.', value: 'validacion_dc', sortable: false },
      { text: 'Comentarios', value: 'comentarios' },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
    puestos:[11, 12, 40, 54, 56, 68, 107]
  }),

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    canEdit() {
      return [12, 107,11].includes(this.getdatosUsuarioERPERP.idpuesto)
    },
    isDataLoaded() {
      return this.procesos && this.procesos.length ? true : false;
    },
    getNew() {
      return this.isDataLoaded ? this.procesos.filter(it => it.estatus == 'new') : []
    },
    getCompleted() {
      return this.isDataLoaded ? this.procesos.filter(it => it.estatus == 'approved') : []
    },
    getReview() {
      return this.isDataLoaded ? this.procesos.filter(it => it.estatus == 'onReview') : []
    },
    getReject() {
      return this.isDataLoaded ? this.procesos.filter(it => it.estatus == 'refuse') : []
    },
    /** Denominador: todos los procesos listados (incluye aprobados) para que el % de avance tenga sentido. */
    getTotal() {
      return this.isDataLoaded ? this.procesos.length : 0
    },
    avancePorcentaje() {
      if (!this.isDataLoaded || this.getTotal === 0) {
        return 0
      }
      return Math.round((this.getCompleted.length / this.getTotal) * 100)
    },
    procesosFiltrados() {
      let procesosExtendidos = this.procesos.map((proc, index) => ({
        ...proc,
        grabando: false,
        chunks: [],
        validacionDueno: false,
        validacionLider: false,
        validacionSocio: false,
        isPlaying: false,
        audioObj: null,
        /** Clave backend: approved | onReview | refuse | new */
        estatusKey: proc.estatus,
        estatus: this.getEstatus(proc.estatus),
      }));

      if (!this.departamentoFiltro) {
        return procesosExtendidos;
      }
      return procesosExtendidos.filter(proc => proc.id_departamento === this.departamentoFiltro);
    },

    filterJefes() {
      return this.personal.filter(el => (el.puesto.match('JEFE') && !el.puesto.match('ASISTENTE')) || el.puesto.match('DIRECTOR'));
    },

    filterResponsables() {
      return this.personal;
    },
    documentosFiltrados() {
      if (!this.departamentoFiltro) {
        return this.documentosProcesos;
      }
      return this.documentosProcesos.filter(doc => doc.id_departamento === this.departamentoFiltro);
    },
    renderedMarkdown() {
      return this.blueprint ? md.render(this.blueprint) : ''
    },
  },

  async created() {
    await this.initialize();
    await this.getDepartamentos();
    await this.getJefesDepartamento();
    await this.initializeDocumentos();
  },

  methods: {
    showRecording() {
      if ([718].includes(this.getdatosUsuarioERPERP.id_usuario)) {
        return true
      }
      if ([2230, 954].includes(this.getdatosUsuarioERPERP.iderp)) {
        return true
      }
      // Al crear proceso nuevo, permitir grabar al usuario en edición
      if (!this.form.id && this.modoEdicion) {
        return true
      }
      return this.form.id_responsable == this.getdatosUsuarioERPERP.id_trabajador
    },
    initialize() {
      this.cargar = true;
      this.procesos = [];
      this.$http.get('get.todos.los.procesos').then(response => {
        this.procesos = response.data;

        if( !this.accesosProcesos.includes(this.getdatosUsuarioERPERP.iderp) ){
          this.procesos = this.procesos.filter(it => it.id_responsable == this.getdatosUsuarioERPERP.id_trabajador)
        }

        if (this.procesos && this.procesos.length) {
          this.procesos.forEach(it => {
            it.validacion_dueno = it.validacion_dueno ? true : false;
            it.validacion_lider = it.validacion_lider ? true : false;
            it.validacion_socio = it.validacion_socio ? true : false;
          })
        }
        this.cargar = false;
      }).catch(error => {
        this.validarError(error.response.data.message);
      }).finally(() => { this.cargar = false; });
    },

    getDepartamentos() {
      this.cargar = true;
      this.departamentos = [];
      this.$http.get('get.todos.los.departamentos').then(response => {
        this.departamentos = response.data;
        this.cargar = false;
      }).catch(error => {
        this.validarError(error.response.data.message);
      }).finally(() => { this.cargar = false; });
    },
    getJefesDepartamento() {
      this.cargar = true;
      this.personal = [];
      this.$http.get('get.jefes.departamento').then(response => {
        this.personal = response.data;
        this.cargar = false;
      }).catch(error => {
        this.validarError(error.response.data.message);
      }).finally(() => { this.cargar = false; });
    },
    getEstatus(sts) {
      const estatusMap = {
        approved: 'Aprobado',
        onReview: 'En Revisión',
        refuse: 'Rechazado',
        new: 'Nuevo'
      };
      const key =
        sts && typeof sts === 'string'
          ? String(sts).trim()
          : sts;
      if (Object.prototype.hasOwnProperty.call(estatusMap, key)) {
        return estatusMap[key];
      }
      if (sts === 'En Revisión' || sts === 'Aprobado' || sts === 'Rechazado' || sts === 'Nuevo') {
        return sts;
      }
      return sts || '';
    },

    getColorEstatus(estatus, estatusKey) {
      if (estatusKey === 'approved') return 'green darken-2';
      const texto = typeof estatus === 'string' ? estatus.trim().toLowerCase() : '';
      if (texto === 'aprobado' || texto === 'approve') return 'green darken-2';
      if (texto.includes('revisión') || texto.includes('revision')) return 'amber darken-2';
      if (texto === 'rechazado') return 'red darken-2';
      if (texto === 'nuevo') return 'grey darken-1';
      return 'grey darken-1';
    },

    abrirDialog(item, edit) {
      const raw = this.procesos.find((p) => p.id === item.id)
      this.form = { ...item }
      delete this.form.estatusKey
      delete this.form.grabando
      delete this.form.chunks
      delete this.form.isPlaying
      delete this.form.audioObj
      if (raw != null && raw.estatus != null) {
        this.form.estatus = raw.estatus
      }
      if (this.form.escuela == null || this.form.escuela === undefined || this.form.escuela === '') {
        this.form.escuela = 1;
      }
      this.resetAudioState()
      if (item.audio_name) {
        this.audioName = item.audio_name
        this.transcripcion = item.transcription || ''
        this.pdfURL = item.pdf_name || ''
      }
      this.archivoProcesoPdf = null;
      this.diagramaProcesoPdf = null;
      this.archivoProcesoExistente = this.getPdfNombre(item, 'archivo') || '';
      this.diagramaProcesoExistente = this.getPdfNombre(item, 'diagrama') || '';
      this.eliminarArchivoProcesoPdf = false;
      this.eliminarDiagramaProcesoPdf = false;
      const acceso = this.tieneAccesoAlProceso(item)
      this.modoEdicion = false;
      this.dialog = true;
      if (edit) {
        this.puedeEditar = acceso;
      }
    },


    crearProceso() {
      this.form = {
        id: null,
        id_departamento: '',
        id_usuario: '',
        nombre_completo: '',
        titulo: '',
        proceso: '',
        observacion: '',
        id_jefe_departamento: '',
        id_responsable: '',
        escuela: 1,
        audioBase64: null,
        audio_name: '',
      };
      this.resetAudioState()
      this.archivoProcesoPdf = null;
      this.diagramaProcesoPdf = null;
      this.archivoProcesoExistente = '';
      this.diagramaProcesoExistente = '';
      this.eliminarArchivoProcesoPdf = false;
      this.eliminarDiagramaProcesoPdf = false;
      this.modoEdicion = true;
      this.dialog = true;
    },

    editarProceso() {
      this.modoEdicion = true;
    },
    canGestionarDueno(item) {
      return Number(item.id_usuario) === Number(this.getdatosUsuarioERPERP.iderp);
    },
    canGestionarDirector() {
      return Number(this.getdatosUsuarioERPERP.iderp) === 1;
    },
    canGestionarControlInterno() {
      return Number(this.getdatosUsuarioERPERP.iderp) === 718;
    },
    canValidarDueno(item) {
      return this.canGestionarDueno(item);
    },
    canValidarDirector(item) {
      if (!this.canGestionarDirector()) return false;
      if (item.validacion_lider) return true;
      return !!item.validacion_dueno;
    },
    canValidarControlInterno(item) {
      if (!this.canGestionarControlInterno()) return false;
      if (item.validacion_socio) return true;
      return !!item.validacion_lider;
    },
    updateTareaCheck(item, from) {
      if (from === 'dueno' && !this.canValidarDueno(item)) return;
      if (from === 'lider' && !this.canValidarDirector(item)) return;
      if (from === 'socio' && !this.canValidarControlInterno(item)) return;

      const nextDueno = from === 'dueno' ? !item.validacion_dueno : !!item.validacion_dueno;
      const nextLiderBase = from === 'lider' ? !item.validacion_lider : !!item.validacion_lider;
      const nextSocioBase = from === 'socio' ? !item.validacion_socio : !!item.validacion_socio;
      const nextLider = nextDueno ? nextLiderBase : false;
      const nextSocio = (nextDueno && nextLider) ? nextSocioBase : false;

      this.confirmTitulo = "Confirmación"
      if (from == 'dueno') {
        this.confirmMensaje = nextDueno
          ? "¿Marcar como válido al dueño del proceso?"
          : "¿Regresar a inválido al dueño del proceso?"
      }
      if (from == 'lider') {
        this.confirmMensaje = nextLider
          ? "¿Marcar como válido al director?"
          : "¿Regresar a inválido al director?"
      }
      if (from == 'socio') {
        this.confirmMensaje = nextSocio
          ? "¿Marcar como válido al jefe de control interno?"
          : "¿Regresar a inválido al jefe de control interno?"
      }
      this.form = item
      this.fromValidation = from
      this.validacionDueno = nextDueno
      this.validacionLider = nextLider
      this.validacionSocio = nextSocio
      this.confirm = true
    },
    async requestUpdateValidacion() {
      this.confirm = false
      try {
        const form = {
          id: this.form.id,
          validacion_dueno:this.validacionDueno,
          validacion_lider: this.validacionLider,
          validacion_socio: this.validacionSocio
        }
        
        const response = await this.$http.put('update.validacion', form)

        if (response.data) {
          this.form = {}
          this.fromValidation = null
          this.validacionDueno = null
          this.validacionLider = null
          this.validacionSocio = null

          this.validarSuccess('Proceso actualizado correctamente');
          this.initialize();
        }

      } catch (error) {
        console.error(error);
      }
    },
    guardar() {
      if (!this.form.titulo) {
        this.$swal({
          icon: 'warning',
          title: 'Campos incompletos',
          text: 'Debes llenar el título y el proceso.',
        });
        return;
      }
      if (!this.form.id_usuario) {
        this.form.id_usuario = this.getdatosUsuarioERPERP.id_usuario;
        this.form.nombre_completo = this.getdatosUsuarioERPERP.nombre_completo;
      }

      this.showSkeleton = true

      const formData = new FormData();
      formData.append('id', this.form.id);
      formData.append('titulo', this.form.titulo);
      formData.append('proceso', this.form.proceso);
      formData.append('id_usuario', this.form.id_usuario);
      formData.append('estatus', this.form.estatus);
      formData.append('id_responsable', this.form.id_responsable);
      formData.append('id_jefe_departamento', this.form.id_jefe_departamento);
      formData.append('validacion_dueno', this.form.validacion_dueno);
      formData.append('validacion_lider', this.form.validacion_lider);
      formData.append('validacion_socio', this.form.validacion_socio);
      formData.append('nombre_completo', this.form.nombre_completo);
      formData.append('id_departamento', this.form.id_departamento);
      formData.append('escuela', this.form.escuela || 1);

      if (this.archivoProcesoPdf) {
        formData.append('archivo_proceso_pdf', this.archivoProcesoPdf);
      }
      if (this.diagramaProcesoPdf) {
        formData.append('diagrama_proceso_pdf', this.diagramaProcesoPdf);
      }
      formData.append('eliminar_archivo_proceso_pdf', this.eliminarArchivoProcesoPdf ? 1 : 0);
      formData.append('eliminar_diagrama_proceso_pdf', this.eliminarDiagramaProcesoPdf ? 1 : 0);

      if (this.audioBlob) {
        formData.append('audio', this.audioBlob, 'grabacion.webm');
      } else if (this.archivoAudio) {
        const nombreAudio = this.archivoAudio.name || 'audio.webm';
        formData.append('audio', this.archivoAudio, nombreAudio);
      }

      this.cargar = true;
      this.$http.post('crear.proceso', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 1500000
      }).then(response => {
        const { success, proceso } = response.data
        if (success) {
          const hayTexto = proceso && proceso.transcripcion && proceso.transcripcion.texto
          this.validarSuccess(hayTexto
            ? 'Proceso guardado. Ya puedes descargar el Word con la transcripción.'
            : 'Proceso guardado correctamente');
          this.initialize();
          this.archivoProcesoExistente = this.getPdfNombre(proceso || this.form, 'archivo') || '';
          this.diagramaProcesoExistente = this.getPdfNombre(proceso || this.form, 'diagrama') || '';
          if (proceso && proceso.transcripcion) {
            const transc = proceso.transcripcion
            this.transcripcion = transc.texto || ''
            this.docxBase64 = transc.docxBase64 || ''
            this.pdfBase64 = transc.pdf || ''
            this.pdfName = (transc.pdf_name) ? transc.pdf_name : this.pdfName
            this.pdfURL = transc.pdf_name || ''
            if (transc.blueprint && transc.blueprint.blueprint) {
              this.blueprint = transc.blueprint.blueprint
            } else if (typeof transc.blueprint === 'string') {
              this.blueprint = transc.blueprint
            }
            if (proceso.audio_name) {
              this.form.audio_name = proceso.audio_name
            }
            if (proceso.archivo_proceso_pdf_name) {
              this.form.archivo_proceso_pdf_name = proceso.archivo_proceso_pdf_name
              this.archivoProcesoExistente = proceso.archivo_proceso_pdf_name
            }
            this.audioBlob = null
            this.archivoAudio = null
            if (this.docxBase64) {
              this.descargarDocxBase64()
            }
          }
        }
        this.modoEdicion = false;
      }).catch(error => {
        let msg = 'Error al guardar el proceso'
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message
        }
        this.validarError(msg);
      }).finally(() => {
        this.cargar = false;
        this.showSkeleton = false
      });
    },

    resetAudioState() {
      this.audioUrl = null
      this.audioBlob = null
      this.archivoAudio = null
      this.isRecording = false
      this.hasRecordedAudio = false
      this.transcripcion = ''
      this.docxBase64 = ''
      this.blueprint = ''
      this.pdfBase64 = ''
      this.pdfURL = ''
      this.audioName = ''
      if (this.form) {
        this.form.audioBase64 = null
      }
    },
    iniciarGrabacionDesdeGuia() {
      this.modoEdicion = true
      this.dialog = true
      this.startRecording()
    },
    async startRecording() {
      try {
        this.audioStream = await navigator.mediaDevices.getUserMedia({ audio: true })
        this.mediaRecorder = new MediaRecorder(this.audioStream)
        this.audioChunks = []
        this.isRecording = true
        this.archivoAudio = null

        this.mediaRecorder.ondataavailable = (e) => {
          this.audioChunks.push(e.data)
        }

        this.mediaRecorder.onstop = () => {
          this.audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' })
          this.audioUrl = URL.createObjectURL(this.audioBlob)
          this.hasRecordedAudio = true
          this.convertBlobToBase64(this.audioBlob)
          this.audioChunks = []
          this.isRecording = false
          if (this.audioStream) {
            this.audioStream.getTracks().forEach(track => track.stop())
            this.audioStream = null
          }
        }

        this.mediaRecorder.start()
      } catch (err) {
        console.error(err)
        this.validarError('No se pudo acceder al micrófono. Verifica permisos.')
      }
    },
    stopRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop()
      }
    },
    onAudioFileChange(file) {
      if (!file) return
      const tipo = file.type || ''
      if (tipo && !tipo.startsWith('audio/') && tipo !== 'video/webm') {
        this.validarError('Solo se permiten archivos de audio.')
        this.archivoAudio = null
        return
      }
      this.audioBlob = null
      this.audioUrl = URL.createObjectURL(file)
      this.hasRecordedAudio = true
      this.form.audioBase64 = null
    },
    clearAudio() {
      if (this.audioUrl && String(this.audioUrl).startsWith('blob:')) {
        URL.revokeObjectURL(this.audioUrl)
      }
      this.audioUrl = null
      this.audioBlob = null
      this.archivoAudio = null
      this.hasRecordedAudio = false
      if (this.form) {
        this.form.audioBase64 = null
      }
    },
    convertBlobToBase64(blob) {
      const reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onloadend = () => {
        this.form.audioBase64 = reader.result
      }
    },
    getAudioSrc(base64) {
      return base64 || null
    },
    detenerAudio(item) {
      if (item.audioObj) {
        item.audioObj.pause()
        item.audioObj.currentTime = 0
      }
      item.isPlaying = false
    },
    detenerTodosLosAudios(exceptItem) {
      this.procesos.forEach(proc => {
        if (exceptItem && proc.id === exceptItem.id) return
        if (proc.audioObj && proc.isPlaying) {
          proc.audioObj.pause()
          proc.audioObj.currentTime = 0
          proc.isPlaying = false
        }
      })
    },
    reproducirAudio(item) {
      if (!item.audio_name) return
      if (item.isPlaying) {
        this.detenerAudio(item)
        return
      }
      this.detenerTodosLosAudios(item)
      if (!item.audioObj) {
        item.audioObj = new Audio(this.URL_AUDIO + item.audio_name)
        item.audioObj.onended = () => {
          item.isPlaying = false
        }
      }
      item.audioObj.play()
        .then(() => { item.isPlaying = true })
        .catch(err => {
          item.isPlaying = false
          console.warn('Error reproduciendo:', err)
          this.validarError('No se pudo reproducir el audio.')
        })
    },
    async descargarAudio(item) {
      if (!item.audio_name) return
      const url = this.URL_AUDIO + item.audio_name
      try {
        const response = await fetch(url)
        const blob = await response.blob()
        const blobUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = item.audio_name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(blobUrl)
      } catch (err) {
        window.open(url, '_blank')
      }
    },
    descargarDocxBase64() {
      if (!this.docxBase64) return
      const byteCharacters = atob(this.docxBase64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], {
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const titulo = this.form && this.form.titulo ? String(this.form.titulo) : 'transcripcion'
      link.setAttribute('download', titulo.replace(/[\\/:*?"<>|]/g, '').trim() + '.docx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    async descargarWord() {
      if (this.docxBase64) {
        this.descargarDocxBase64()
        return
      }
      if (!this.form || !this.form.id) {
        this.validarError('No hay transcripción para descargar.')
        return
      }
      await this.descargarWordProceso(this.form)
    },
    async descargarWordProceso(item) {
      if (!item || !item.id) {
        this.validarError('No hay transcripción para descargar.')
        return
      }
      try {
        const response = await this.$http.get('descargar.transcripcion.word/' + item.id, {
          responseType: 'blob'
        })
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        const titulo = item.titulo ? String(item.titulo) : 'transcripcion'
        link.setAttribute('download', titulo.replace(/[\\/:*?"<>|]/g, '').trim() + '.docx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (error) {
        this.validarError('No se pudo descargar el Word.')
      }
    },
    definePdfDwnl() {
      if (this.pdfURL) {
        this.descargarPdfServe()
      } else if (this.pdfBase64) {
        this.descargarPdfBase64()
      } else if (this.getPdfNombre(this.form, 'archivo')) {
        this.descargarPdfProceso(this.form, 'archivo')
      }
    },
    descargarPdfServe() {
      const url = 'https://escuelakpi.club/pdf-procesos/' + this.pdfURL
      window.open(url, '_blank')
    },
    async descargarPdfBase64() {
      if (!this.pdfBase64) return
      const byteCharacters = atob(this.pdfBase64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.pdfName || 'proceso.pdf')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },

    tieneAccesoAlProceso(item) {
      return item.id_usuario === this.getdatosUsuarioERPERP.iderp || [1, 334, 2345, 2574, 2230, 954].includes(this.getdatosUsuarioERPERP.iderp);
    },

    eliminar(item) {
      if (!this.tieneAccesoAlProceso(item)) return;
      this.$swal({
        title: '¿Eliminar este proceso?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.cargar = true;
          this.$http.delete('eliminar.proceso', { data: { id: item.id } })
            .then(() => {
              this.validarSuccess('Proceso eliminado');
              this.initialize();
            })
            .catch(error => {
              this.validarError(error.response.data.message);
            })
            .finally(() => { this.cargar = false; });
        }
      });
    },
    onPdfChange(file, tipo) {
      if (!file) return;
      if (file.type !== 'application/pdf') {
        this.validarError('Solo se permiten archivos PDF.');
        if (tipo === 'archivo') {
          this.archivoProcesoPdf = null;
        } else {
          this.diagramaProcesoPdf = null;
        }
        return;
      }
      if (tipo === 'archivo') {
        this.eliminarArchivoProcesoPdf = false;
      } else {
        this.eliminarDiagramaProcesoPdf = false;
      }
    },
    eliminarPdfProceso(tipo) {
      if (tipo === 'archivo') {
        this.archivoProcesoPdf = null;
        this.archivoProcesoExistente = '';
        if (this.form) {
          this.form.archivo_proceso_pdf_name = '';
          this.form.pdf_proceso_name = '';
          this.form.archivo_proceso_pdf = '';
          this.form.pdf_name = '';
        }
        this.eliminarArchivoProcesoPdf = true;
      } else {
        this.diagramaProcesoPdf = null;
        this.diagramaProcesoExistente = '';
        if (this.form) {
          this.form.diagrama_proceso_pdf_name = '';
          this.form.pdf_diagrama_name = '';
          this.form.diagrama_proceso_pdf = '';
        }
        this.eliminarDiagramaProcesoPdf = true;
      }
      this.validarSuccess('Archivo marcado para eliminar. Guarda para aplicar cambios.');
    },
    esItemFormularioActual(item) {
      if (!item || !this.form) return false;
      if (item === this.form) return true;
      if (!item.id || !this.form.id) return false;
      return item.id === this.form.id;
    },
    getPdfNombre(item, tipo) {
      if (!item) return '';
      const usarFallbackFormulario = this.esItemFormularioActual(item);
      if (tipo === 'archivo') {
        return item.archivo_proceso_pdf_name || item.pdf_proceso_name || item.archivo_proceso_pdf || item.pdf_name || (usarFallbackFormulario ? this.archivoProcesoExistente : '') || '';
      }
      return item.diagrama_proceso_pdf_name || item.pdf_diagrama_name || item.diagrama_proceso_pdf || (usarFallbackFormulario ? this.diagramaProcesoExistente : '') || '';
    },
    getPdfUrl(item, tipo) {
      const nombre = this.getPdfNombre(item, tipo);
      if (!nombre) return '';
      return `https://escuelakpi.club/kpi/pdf-procesos/${nombre}`;
    },
    verPdf(item, tipo) {
      this.pdfPreviewTipo = tipo;
      this.pdfPreviewItem = item;
      const file = tipo === 'archivo' ? this.archivoProcesoPdf : this.diagramaProcesoPdf;
      if (file instanceof File && this.esItemFormularioActual(item)) {
        this.pdfPreviewUrl = URL.createObjectURL(file);
        this.pdfPreviewTitle = tipo === 'archivo' ? 'Archivo del Proceso' : 'Diagrama del Proceso';
        this.pdfPreviewDialog = true;
        return;
      }
      const url = this.getPdfUrl(item, tipo);
      if (!url) {
        this.validarError('No hay PDF disponible para visualizar.');
        return;
      }
      this.pdfPreviewTitle = tipo === 'archivo' ? 'Archivo del Proceso' : 'Diagrama del Proceso';
      this.pdfPreviewUrl = url;
      this.pdfPreviewDialog = true;
    },
    descargarPdfPreview() {
      if (!this.pdfPreviewTipo || !this.pdfPreviewItem) {
        this.validarError('No hay PDF seleccionado para descargar.');
        return;
      }
      this.descargarPdfProceso(this.pdfPreviewItem, this.pdfPreviewTipo);
    },
    cerrarPreviewPdf() {
      if (this.pdfPreviewUrl && this.pdfPreviewUrl.startsWith('blob:')) {
        URL.revokeObjectURL(this.pdfPreviewUrl);
      }
      this.pdfPreviewDialog = false;
      this.pdfPreviewUrl = '';
      this.pdfPreviewTitle = '';
      this.pdfPreviewTipo = '';
      this.pdfPreviewItem = null;
    },
    descargarPdfProceso(item, tipo) {
      const file = tipo === 'archivo' ? this.archivoProcesoPdf : this.diagramaProcesoPdf;
      if (file instanceof File && this.esItemFormularioActual(item)) {
        const url = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.download = file.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        return;
      }
      const url = this.getPdfUrl(item, tipo);
      if (!url) {
        this.validarError('No hay PDF disponible para descargar.');
        return;
      }
      window.open(url, '_blank');
    },

    // --- MÉTODOS PARA DOCUMENTOS DE PROCESOS ---
    initializeDocumentos() {
      this.cargar = true;
      this.$http.get('get.documentos.procesos').then(response => {
        this.documentosProcesos = response.data;
        this.cargar = false;
      }).catch(error => {
        const mensaje = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Error al obtener documentos';
        this.validarError(mensaje);
      }).finally(() => { this.cargar = false; });
    },

    crearDocumento() {
      this.formDoc = {
        id: null,
        folio: '',
        nombre_documento: '',
        archivo_nombre: '',
        estatus: 'Pendiente',
        validacion_dc: 0,
        comentarios: '',
        id_departamento: ''
      };
      this.archivoDoc = null;
      this.dialogDocumento = true;
    },

    abrirDialogDocumento(item) {
      this.formDoc = { ...item };
      this.archivoDoc = null;
      this.dialogDocumento = true;
    },

    guardarDocumento() {
      if (!this.formDoc.nombre_documento || !this.formDoc.id_departamento) {
        this.$swal({
          icon: 'warning',
          title: 'Campos incompletos',
          text: 'Nombre y Departamento son obligatorios.',
        });
        return;
      }

      if (!this.formDoc.id && !this.archivoDoc) {
        this.$swal({
          icon: 'warning',
          title: 'Archivo faltante',
          text: 'Es obligatorio seleccionar un archivo (PDF o DOC) para subir el proceso.',
        });
        return;
      }

      this.cargar = true;
      const formData = new FormData();
      Object.keys(this.formDoc).forEach(key => {
        if (this.formDoc[key] !== null && this.formDoc[key] !== undefined) {
          formData.append(key, this.formDoc[key]);
        }
      });

      if (this.archivoDoc) {
        formData.append('archivo', this.archivoDoc);
      }

      formData.append('id_usuario_subio', this.getdatosUsuarioERPERP.id_usuario);

      this.$http.post('crear.documento.proceso', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(response => {
        if (response.data.success) {
          this.validarSuccess('Documento guardado correctamente');
          this.initializeDocumentos();
          this.dialogDocumento = false;
        }
      }).catch(error => {
        const mensaje = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Error al guardar documento';
        this.validarError(mensaje);
      }).finally(() => { this.cargar = false; });
    },

    eliminarDocumento(item) {
      this.$swal({
        title: '¿Eliminar este documento?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.cargar = true;
          this.$http.delete('eliminar.documento.proceso', { data: { id: item.id } })
            .then(() => {
              this.validarSuccess('Documento eliminado');
              this.initializeDocumentos();
            })
            .catch(error => {
              const mensaje = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Error al eliminar';
              this.validarError(mensaje);
            })
            .finally(() => { this.cargar = false; });
        }
      });
    },

    tieneAccesoDoc(item) {
      return item.id_usuario_subio === this.getdatosUsuarioERPERP.id_usuario ||
        this.puestos.includes(this.getdatosUsuarioERPERP.idpuesto);
    },

    descargarDocumento(item) {
      if (!item.archivo_nombre) return;
      const url = '/documentos-procesos/' + item.archivo_nombre;
      this.cargar = true;
      this.$http.get(url, { responseType: 'blob' })
        .then(response => {
          // Extraer la extensión del nombre de archivo real en el servidor
          const extension = item.archivo_nombre.split('.').pop();
          
          // Asegurar que el nombre de descarga tenga la extensión
          let nombreDescarga = item.nombre_documento || 'documento';
          if (!nombreDescarga.toLowerCase().endsWith('.' + extension.toLowerCase())) {
            nombreDescarga += '.' + extension;
          }

          // Crear el blob con el tipo que viene del servidor
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          const urlBlob = window.URL.createObjectURL(blob);
          
          const link = document.createElement('a');
          link.href = urlBlob;
          link.setAttribute('download', nombreDescarga);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(urlBlob);
        })
        .catch(error => {
          console.error('Error al descargar:', error);
          this.validarError('No se pudo descargar el archivo.');
        })
        .finally(() => { this.cargar = false; });
    },
  },


}
</script>

<style>
/* Estilos existentes para Quill */
.ql-editor ol {
  counter-reset: myCounter;
  padding-left: 2em;
  margin-bottom: 1em;
}

.ql-editor ol>li {
  list-style: none;
  counter-increment: myCounter;
  margin-bottom: 0.25em;
}

.ql-editor ol>li::before {
  content: counter(myCounter) ".- ";
  font-weight: bold;
  display: inline-block;
  width: 2em;
}

.ql-editor ul {
  list-style: none;
  padding-left: 1.5em;
  margin-bottom: 1em;
}

.ql-editor ul>li {
  position: relative;
  padding-left: 1em;
  margin-bottom: 0.25em;
}

.ql-editor ul>li::before {
  content: "•";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  font-weight: bold;
}

.max-scroll-text {
  max-height: 6rem;
  /* ≈ 4-5 líneas */
  overflow-y: auto;
  padding-right: 8px;
  /* evita que la barra tape texto */
}
</style>